<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="String(size)"
    :height="String(size)"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    :stroke-width="strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="yn-svg-icon yn-svg-icon-layout"
  >
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" /><line x1="3" y1="9" x2="21" y2="9" /><line x1="9" y1="21" x2="9" y2="9" />
  </svg>
</template>

<script setup>
defineProps({
  size: { type: [String, Number], default: '16' },
  strokeWidth: { type: [String, Number], default: 2 },
})
</script>
